import { styled } from '@mui/system';

const Footer = styled('footer')(({ theme }) => ({
  color: theme.palette.secondary.main,
  padding: '1rem',
  background: theme.palette.secondary.mobileToggleColor,
}));

export default Footer;
